<div class="modal-header">
  <h5 class="modal-title" id="notificationViewModalLabel">
    <i class="bi bi-info-circle me-2 text-primary"></i>
    {{ notification.titre || 'Détails de la notification' }}
  </h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
  <div class="d-flex align-items-start mb-3">
    @if (notification.avatar) {
      <div class="position-relative me-3 flex-shrink-0">
        <img src="{{notification.avatar}}" class="rounded-circle avatar-sm shadow-sm" alt="user-pic">
        <span class="active-badge position-absolute start-100 translate-middle p-1 bg-success rounded-circle shadow-sm">
          <span class="visually-hidden"></span>
        </span>
      </div>
    }@else {
      <div class="avatar-sm me-3 flex-shrink-0 shadow-sm">
        <span class="avatar-title {{notification.background}} rounded-circle fs-lg d-flex align-items-center justify-content-center">
          <i class="{{notification.icon}}"></i>
        </span>
      </div>
    }
    <div class="flex-grow-1">
      <h6 class="mb-0 fs-md fw-semibold text-primary">{{ notification.titre || 'System Notification' }}</h6>
      <p class="text-muted fs-sm mb-0">
        <i class="bi bi-clock me-1 fs-xs"></i>
        {{notification.timestamp | timeAgo }}
      </p>
    </div>
  </div>

  <div class="notification-content fs-md" 
       [attr.dir]="currLang === 'ar' ? 'rtl' : 'ltr'"
       [innerHTML]="currLang === 'ar' ? notification.contenuAr : notification.contenu"></div>

  @if (notification.dateExpiration) {
    <hr>
    <div class="alert alert-info py-2 px-3 mb-0">
      <p class="mb-0 fs-sm"><i class="bi bi-exclamation-triangle me-2"></i>Cette notification expire le: {{ notification.dateExpiration | date:'medium' }}</p>
    </div>
  }

  @if (showConfirmDialog) {
    <hr>
    <div class="alert alert-warning py-2 px-3 mb-0">
      <p class="mb-2 fs-sm">Êtes-vous sûr de vouloir supprimer cette notification ?</p>
      <div class="d-flex justify-content-end">
        <button type="button" class="btn btn-sm btn-outline-danger me-2" (click)="confirmDelete()">Confirmer la suppression</button>
        <button type="button" class="btn btn-sm btn-outline-secondary" (click)="cancelDelete()">Annuler</button>
      </div>
    </div>
  }

  @if (message) {
    <hr>
    <div class="alert alert-danger py-2 px-3 mt-3">
      <p class="mb-0 fs-sm">{{ message }}</p>
    </div>
  }
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-danger" (click)="removeNotification()" [disabled]="showConfirmDialog">Supprimer</button>
  <button type="button" class="btn btn-secondary" (click)="closeModal()">Fermer</button>
</div>
